import React, { useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Collapse,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "80%",
    marginTop: "8px",
  },
  required: {
    color: "red",
    marginLeft: "4px",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  backButton: {
    borderRadius: "20px",
    textTransform: "none",
    backgroundColor: "#707070",
    color: "#FFFFFF",
    '&:hover': {
      backgroundColor: "#505050", // Darker color on hover
    },
  },
}));

const EcosystemDetails = (props) => {
  const classes = useStyles();

  const {
    ecosystemDetails,
    ecosystemTypesData,
    rolesAndTypesData,
    handleEcosystemTypeChange,
    handleEcosystemUrlChange,
    errors,
    handleNext,
    handleBack,
  } = props;

  const { selectedEcosystemType, ecosystemUrl, selectedEcosystemId } =
    ecosystemDetails;
  const [openRows, setOpenRows] = useState({});

  const handleRowClick = (id) => {
    setOpenRows((prevOpenRows) => ({
      ...prevOpenRows,
      [id]: !prevOpenRows[id],
    }));
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.inline}>
            Ecosystem Details
          </Typography>
          <hr className={classes.hrLine} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Ecosystem Type<span className={classes.required}>*</span>
          </Typography>
          <TextField
            size="small"
            select
            variant="outlined"
            className={classes.textfieldWidth}
            value={selectedEcosystemType}
            onChange={handleEcosystemTypeChange}
            error={errors.selectedEcosystemType !== ""}
            helperText={errors.ecosystemType}
          >
            {ecosystemTypesData.map((type) => (
              <MenuItem
                key={type.ecosystemTypeId}
                value={type.ecosystemTypeName}
              >
                {type.ecosystemTypeName}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Ecosystem ID
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            className={classes.textfieldWidth}
            value={selectedEcosystemId}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        {rolesAndTypesData.length > 0 && (
          <Grid item xs={12}>
            <TableContainer component={Paper} style={{ width: "90%" }}>
              <Table>
                <TableHead>
                  <TableRow
                  // style={{ backgroundColor: "#C6C6C6" }}
                  >
                    <TableCell style={{ width: "10%" }} />
                    <TableCell style={{ width: "25%" }}>
                      Collaborator Type
                    </TableCell>
                    <TableCell style={{ width: "20%" }}>
                      Collaborator ID
                    </TableCell>
                    <TableCell style={{ width: "30%" }}>User Roles</TableCell>
                    <TableCell style={{ width: "25%" }}>User Role ID</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rolesAndTypesData.map((collaborator, index) => (
                    <React.Fragment key={collaborator.collaborator_type_id}>
                      <TableRow
                        // style={{
                        //   backgroundColor: index % 2 !== 0 ? "lightblue" : "",
                        // }}
                        style={{ backgroundColor: "#F9F9FC" }}
                      >
                        <TableCell style={{ width: "10%" }}>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() =>
                              handleRowClick(collaborator.collaborator_type_id)
                            }
                          >
                            {openRows[collaborator.collaborator_type_id] ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell style={{ width: "25%" }}>
                          {collaborator.collaborator_type_name}
                        </TableCell>
                        <TableCell style={{ width: "20%" }}>
                          {collaborator.collaborator_type_id}
                        </TableCell>
                        <TableCell style={{ width: "30%" }} />
                        <TableCell style={{ width: "25%" }} />
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ padding: 0 }} colSpan={5}>
                          <Collapse
                            in={openRows[collaborator.collaborator_type_id]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Table>
                              <TableBody>
                                {collaborator.roles.map((role, index) => (
                                  <TableRow
                                    key={role.collaborator_role_id}
                                    // style={{
                                    //   backgroundColor:
                                    //     index % 2 === 0 ? "lightblue" : "",
                                    // }}
                                  >
                                    <TableCell
                                      style={{ width: "10%" }}
                                    ></TableCell>

                                    <TableCell style={{ width: "25%" }}>
                                      {collaborator.collaborator_type_name}
                                    </TableCell>
                                    <TableCell style={{ width: "20%" }}>
                                      {collaborator.collaborator_type_id}
                                    </TableCell>
                                    <TableCell style={{ width: "30%" }}>
                                      {role.role_name}
                                    </TableCell>
                                    <TableCell style={{ width: "25%" }}>
                                      {role.collaborator_role_id}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Ecosystem URL<span className={classes.required}>*</span>
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            className={classes.textfieldWidth}
            value={ecosystemUrl}
            onChange={handleEcosystemUrlChange}
            error={errors.ecosystemUrl !== ""}
            helperText={errors.ecosystemUrl}
            onInput={(e) => {
              e.target.value = e.target.value.replace(
                /[^a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=%]/g
              );
              // .replace(/\/{2,}/g, "/");
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{ paddingTop: "24px", paddingBottom: "24px" }}
        >
          <Typography>
            <span style={{ fontWeight: "500" }}>Note: </span>All fields marked
            with an asterisk (<span style={{ color: "red" }}>*</span>) are
            mandatory.
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          <Button
            variant="contained"
            // color="secondary"
            startIcon={<ChevronLeft />}
            className={classes.backButton}
            onClick={handleBack}
          >
            Back
          </Button>

          <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
              marginRight: "7rem",
            }}
            onClick={handleNext}
            disabled={
              [
                "selectedEcosystemType",
                "selectedEcosystemId",
                "ecosystemUrl",
              ].some((field) => ecosystemDetails[field] === "") ||
              [
                "selectedEcosystemType",
                "selectedEcosystemId",
                "ecosystemUrl",
              ].some((field) => errors[field] !== "")
            }
          >
            Save & Next
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default EcosystemDetails;
